import * as React from 'react';

export interface ISvgIconProps extends React.HTMLAttributes<HTMLElement> {
  /**
   * Custom class to style the icon.
   */
  className?: string;
}
